module.exports = __webpack_public_path__ + "static/img/icon-avatar.c9b348fa.png";